// extracted by mini-css-extract-plugin
export var addButton = "_b1-0";
export var border = "_b1-8";
export var check = "_b1-h";
export var danger = "_b1-6";
export var dropdownContainer = "_b1-1";
export var editModalBody = "_b1-j";
export var footerContainer = "_b1-i";
export var fullWidth = "_b1-a";
export var hide = "_b1-9";
export var icon = "_b1-3";
export var input = "_b1-7";
export var inputFlex = "_b1-b";
export var inputWrapper = "_b1-c";
export var manualFocus = "_b1-5";
export var optionButton = "_b1-4";
export var pillWrapper = "_b1-e";
export var pointer = "_b1-2";
export var showOverflow = "_b1-f";
export var tagsFlex = "_b1-d";
export var xButton = "_b1-g";